// **********************************************************
// Card Slider
// **********************************************************

const locationListSlider = document.querySelectorAll('[data-slider="location-list-slider"]');

const locationListSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 12,
  speed: 300,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  watchOverflow: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
};

locationListSlider.forEach((el) => {
  const parent = el.closest('.location-list');
  const paginationElement = parent.querySelector('.swiper-pagination');

  const arrowRight = parent.querySelector('.arrow-right');
  const arrowLeft = parent.querySelector('.arrow-left');
  locationListSliderOptions.pagination.el = paginationElement;

  locationListSliderOptions.navigation.nextEl = arrowRight;
  locationListSliderOptions.navigation.prevEl = arrowLeft;

  new Swiper(el, locationListSliderOptions);
});
